export default __webpack_public_path__ + "static/media/testocr.a267fe08.png";